module.exports = __webpack_public_path__ + "img/stick-o-vision-instructions.711acab5.png";